<template>
  <div>
    <v-chip :disabled="selectedGroups.length === 0" small class="mr-3" @click.stop="selectedGroups = []">{{ $t('removeTagsSelection') }}</v-chip>

    <v-chip-group v-model="selectedGroups" column multiple color="accent">
      <v-chip filter dark v-for="group in groups" :key="group.id" :value="group.id" small class="mr-1 text--white">{{ group.name }}</v-chip>
    </v-chip-group>
  </div>
</template>

<script>
export default {
  name: 'GroupsSelection',
  props: {
    groups: { type: Array, default: () => [] },
  },
  computed: {
    selectedGroups: {
      // getter
      get() {
        return this.$store.state.forms.selectedGroups;
      },
      // setter
      set(value) {
        this.$store.commit('forms/setSelectedGroups', { value });
      },
    },
  },
};
</script>

<style></style>
